
import SamplePlugin from './sample-plugin.js';

export default [
	SamplePlugin
];
